import React from 'react'
import {
  DataObjectId,
  findIdInWorkflow,
  getWorkflowStage,
  Stage,
  Workflow,
  workflowToConfig
} from 'yougile-model'
import {ActionItem} from './action-item'

interface StageActionsProps {
  taskId: DataObjectId
  workflow: Workflow
  stagePath: string[]
}

const findStage = (props: StageActionsProps): Stage | undefined => {
  const {workflow, stagePath} = props
  if (stagePath.length === 1) {
    const config = workflowToConfig(workflow)
    const key = stagePath[0]
    if (key === 'start' || key === 'create') {
      return {name: `special:${key}`, ...config[key]}
    } else {
      return undefined
    }
  }
  const id = findIdInWorkflow(workflow.ids, ...stagePath)
  return getWorkflowStage(workflow, id)
}

export const StageActions = (props: StageActionsProps) => {
  const stage = findStage(props)
  return (
    <>
      {stage?.actions?.map(action => (
        <ActionItem
          key={action.name}
          {...props}
          actionPath={[...props.stagePath, action.name]}
        />
      ))}
    </>
  )
}
